import ApiBase from './Api'

const CACHE_API_PATHS = {
    CACHE: '/admin/cacheinvalidate',
}

class CacheApi extends ApiBase {
    async latestUpdateForResource(resource: string, id?: string) {
        if (!resource) {
            throw new Error('resource is required')
        }
        const idPart = id ? `/${id}` : ''

        const headers = await this._headRequest(`/${resource}${idPart}`)
        return headers ? headers['last-modified'] : null
    }

    async invalidate() {
        const response: { message: string } = await this._postRequest(CACHE_API_PATHS.CACHE, {})

        return response
    }
}

export default CacheApi
